"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToTableProps({ data, mappers, packages }) {
    let richText = null;
    let tableData;
    if ('tableReference' in data &&
        typeof data.tableReference === 'object' &&
        data.tableReference &&
        'mainContent' in data.tableReference) {
        tableData = data.tableReference;
        richText = mappers.mapRichText({
            richText: data.tableReference.mainContent,
            mappers,
            packages,
        });
    }
    else {
        tableData = data;
    }
    if (!tableData)
        return {};
    return {
        children: richText,
        leftColumnAlignment: 'leftAlign' in tableData ? tableData.leftAlign : undefined,
        mobileComparison: 'mobileComparison' in tableData ? tableData.mobileComparison : undefined,
    };
}
exports.default = mapToTableProps;
